import { Button } from "@heroui/react"
import classes from "../styles/Teachers.module.scss"
import { useNavigate } from "react-router-dom"
import useCategories from "../hooks/useCategoriesSearch"
import CategoriesTable from "../components/Tables/CategoriesTable"

const Articles = () => {
  const { categories, loading } = useCategories()

  const navigate = useNavigate()

  const onNewCategoryClick = () => {
    navigate("/category/new")
  }

  return (
    <div className={classes.root}>
      <div className={classes.actions}>
        <div />
        <div>
          <Button onClick={onNewCategoryClick}>קטגוריה חדשה</Button>
        </div>
      </div>
      <CategoriesTable categories={categories} loading={loading} />
    </div>
  )
}

export default Articles
